import React from 'react';
import { connect } from 'react-redux';
import styles from './skills.module.scss';
import { Helmet } from 'react-helmet';

const Skills = ({showHelmet = true, words}) => {
    const skillGroups = [
        {
            title: 'Frontend',
            items: [
                { name: 'React', level: 92 },
                { name: 'Next.js', level: 84 },
                { name: 'TypeScript', level: 84 },
                { name: 'JavaScript', level: 90 },
                { name: 'Sass / SCSS', level: 88 },
                { name: 'Svelte', level: 76 },
                { name: 'Jest', level: 76 },
                { name: 'GraphQL', level: 70 }, 
            ]
        },
        {
            title: 'Backend',
            items: [
                { name: 'Node.js', level: 86 },
                { name: 'Express', level: 84 },
                { name: 'NestJS', level: 74 },
                { name: 'REST APIs', level: 88 },
                { name: 'MongoDB', level: 82 },
                { name: 'MySQL', level: 72 },
            ]
        },
        {
            title: 'Mobile & Desktop',
            items: [
                { name: 'React Native', level: 82 },
                { name: 'Electron', level: 78 },
            ]
        },
        {
            title: 'Data & Tooling',
            items: [
                { name: 'Webpack', level: 68 },
                { name: 'Git', level: 88 }
            ]
        },
        {
            title: 'AI Tools & Workflow',
            items: [
                { name: 'Windsurf', level: 88 },
                { name: 'Cursor', level: 82 },
                { name: 'GitHub Copilot', level: 84 },
                { name: 'Prompt Engineering', level: 82 },
                { name: 'AI-assisted Debugging', level: 80 },
                { name: 'AI Prototyping', level: 78 }
            ]
        }
    ];

    return(
        <>
            {showHelmet && <Helmet>
                <meta 
                    name="keywords" 
                    content="HTML, CSS, SCSS, javascript, react, git, redux, node, express, next.js, nest.js, typescript, mongodb"
                />
                <meta
                    name="description"
                    content="Programing skills of Arman Gharibyan"
                />
                <title>{words.skillsTitle}</title>
            </Helmet>}
            <section className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.kicker}>{words.skills}</div>
                    <h2 className={styles.title}>{words.skillsTitle}</h2>
                </div>
                <div className={styles.grid}>
                    {skillGroups.map((group) => (
                        <article key={group.title} className={styles.groupCard}>
                            <div className={styles.groupTitle}>{group.title}</div>
                            <div className={styles.skillList}>
                                {group.items.map((item) => (
                                    <div key={item.name} className={styles.skillRow}>
                                        <div className={styles.itemTop}>
                                            <span className={styles.itemTitle}>{item.name}</span>
                                            <span className={styles.itemLevel}>{item.level}%</span>
                                        </div>
                                        <div className={styles.progressTrack}>
                                            <div className={styles.progressBar} style={{ width: `${item.level}%` }}></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </>
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(Skills)